var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmileSad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10668_39)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6275 0 24 5.37259 24 12C24 18.6275 18.6275 24 12 24C5.37259 24 0 18.6275 0 12ZM12 1.71429C6.31936 1.71429 1.71429 6.31936 1.71429 12C1.71429 17.6807 6.31935 22.2857 12 22.2857C17.6807 22.2857 22.2857 17.6807 22.2857 12C22.2857 6.31935 17.6807 1.71429 12 1.71429Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4924 14.7137C10.6785 13.9752 7.8969 15.6079 7.16871 18.2294C7.04201 18.6855 6.56954 18.9526 6.11342 18.8259C5.65731 18.6992 5.39026 18.2267 5.51696 17.7706C6.50273 14.2218 10.2333 12.0833 13.9324 13.0568L13.9398 13.0587L13.9398 13.0588C16.1358 13.6577 17.877 15.4349 18.6417 17.7289C18.7914 18.178 18.5487 18.6635 18.0996 18.8132C17.6505 18.9628 17.1651 18.7201 17.0154 18.271C16.4091 16.4522 15.0662 15.1443 13.4924 14.7137Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.05675 8.91428C9.12968 8.78821 9.17142 8.64184 9.17142 8.48571C9.17142 8.01233 8.78767 7.62857 8.31428 7.62857C7.6042 7.62857 7.02856 8.20421 7.02856 8.91428C7.02856 9.62436 7.6042 10.2 8.31428 10.2C8.78767 10.2 9.17142 9.81624 9.17142 9.34286C9.17142 9.18673 9.12968 9.04036 9.05675 8.91428Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45715 8.48571C7.45715 8.01233 7.84091 7.62857 8.3143 7.62857C9.02437 7.62857 9.60001 8.20421 9.60001 8.91428C9.60001 9.62436 9.02437 10.2 8.3143 10.2C7.84091 10.2 7.45715 9.81624 7.45715 9.34286C7.45715 9.18673 7.49889 9.04036 7.57182 8.91428C7.49889 8.78821 7.45715 8.64184 7.45715 8.48571Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5996 8.91428C16.6725 8.78821 16.7143 8.64184 16.7143 8.48571C16.7143 8.01233 16.3305 7.62857 15.8571 7.62857C15.147 7.62857 14.5714 8.20421 14.5714 8.91428C14.5714 9.62436 15.147 10.2 15.8571 10.2C16.3305 10.2 16.7143 9.81624 16.7143 9.34286C16.7143 9.18673 16.6725 9.04036 16.5996 8.91428Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 8.48571C15 8.01233 15.3838 7.62857 15.8571 7.62857C16.5672 7.62857 17.1429 8.20421 17.1429 8.91428C17.1429 9.62436 16.5672 10.2 15.8571 10.2C15.3838 10.2 15 9.81624 15 9.34286C15 9.18673 15.0417 9.04036 15.1147 8.91428C15.0417 8.78821 15 8.64184 15 8.48571Z",
    fill: "black",
    fillOpacity: 0.87
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10668_39"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmileSad);
export default __webpack_public_path__ + "static/media/smileSad.47ff1b954934d9ddc55fbbdc3dfb05e1.svg";
export { ForwardRef as ReactComponent };